import { Button, ButtonGroup, FormControl, FormHelperText, Grid, Input, InputLabel, Tooltip } from '@material-ui/core';
import { HelpRounded } from '@material-ui/icons';
import React from 'react';
import TranslateInputSwitch from './TranslateInputSwitch';
import { LocalizationConfig } from '../../../config/app';
import { DataApi } from '../../../providers/api-provider';
import { handleStateChangeFromProps, Loader, renderStringAsHtml, showError } from './helpers';
import GlobalStore from "../../../providers/global-store-provider";

export default class TextInput extends React.Component {
    constructor(props) {
        super(props);
        if (props.localize) {
            const value = {};
            LocalizationConfig.locales.forEach(function (item) {
                value[item.code] = '';
            });
            this.state.value = value;
        }
    }
    state = {
        error: undefined,
        value: '',
        enabled: '',
        onChange: null,
        type: 'text',
        name: '',
        title: '',
        width: 12,
        extra: {},
        disabled: false,
        className: '',
        autoComplete: true,
        description: '',
        hidden: false,
        required: false,
        localize: false,
        currentLocale: LocalizationConfig.default,
        translationLoading: false,
    }
    /*
   -----------------------------------------------------------------------
   API Functions
   -----------------------------------------------------------------------
   */

    performTranslationAction = async () => {
        this.setState({ translationLoading: true });
        try {
            const res = await DataApi.create((GlobalStore.state.auth.user.role==='student'?'':'admin')+'/utils/translate', {
                data: this.state.value[this.state.currentLocale],
            });
            this.state.onChange({
                target: {
                    type: 'textarea',
                    value: { ...this.state.value, [LocalizationConfig.default]: res.data },
                    name: this.state.name,
                }
            });
            this.setState({ translationLoading: false, currentLocale: LocalizationConfig.default });
        } catch (e) {
            showError(e);
            this.setState({ translationLoading: false });
        }
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    static getDerivedStateFromProps(nextProps, prevState) {
        return handleStateChangeFromProps(nextProps, prevState)
    }
    onChange = (e) => {
        let value = e.target.value;
        if (this.props.max && e.target.value > this.props.max)
            value = this.props.max;
        if (value && this.props.localize)
            value = { ...this.state.value, [this.state.currentLocale]: value }
        this.props.onChange({
            target: {
                type: 'input',
                value: value,
                name: this.state.name,
            }
        })
    }
    changeLocale = (newLocale) => () => {
        this.setState({ currentLocale: newLocale });
    }
    render() {
        const { error, value, enabled, type, name, title, width, disabled, extra, translationLoading,
            className, autoComplete, description, hidden, required, localize, currentLocale } = this.state;

        if (hidden) {
            if (typeof (hidden) !== 'function' || hidden())
                return <div />
        }

        let processedValue = value;
        if (processedValue) {
            if (type === 'datetime-local')
                processedValue = value.replace(' ', 'T');
            else if (localize)
                processedValue = processedValue[currentLocale];
        }
        return (
            <Grid item xs={12} sm={width ? width : 12} className={className}
                style={!localize ? { display: 'flex', alignItems: 'flex-end' } : {}}
                data-form-element={name}>
                {localize && <TranslateInputSwitch
                    performTranslationAction={this.performTranslationAction}
                    translationLoading={translationLoading}
                    currentLocale={currentLocale}
                    changeLocale={this.changeLocale}
                    value={processedValue}
                />
                }
                <FormControl margin={this.props.margin || "normal"}
                    fullWidth error={error && enabled}>
                    {description && <Tooltip title={renderStringAsHtml(description)}
                        className="input-description" placement="left"><HelpRounded fontSize='small' /></Tooltip>}
                    <InputLabel htmlFor={name} {...type && type.indexOf('date') !== -1 ? { shrink: true } : {}}>
                        {title} {required ? '*' : ''}</InputLabel>
                    <Input inputProps={{ 'data-has-value': value ? "true" : "false", ...extra }} id={name}
                        name={name} autoComplete={autoComplete ? type : 'new-password'}
                        type={type} value={processedValue || ''} onChange={this.onChange}
                        disabled={disabled} />
                    {error && enabled ? <FormHelperText>{typeof (error) === 'string' ? error : 'This field is required'}</FormHelperText> : ''}
                </FormControl>
            </Grid>
        );
    }
}
